import { ChangeDetectorRef, Injector, ViewRef } from '@angular/core';
import { BaseComponent } from './base-component';

export class BaseComponentOnPush extends BaseComponent {
  protected cdr: ChangeDetectorRef;

  public get showProgress(): boolean {
    return this.isLoading;
  }

  public set showProgress(value: boolean) {
    this.setLoading(value);
  }

  constructor(injector: Injector, triggerHeaderAction = true) {
    super(triggerHeaderAction);
    this.cdr = injector.get(ChangeDetectorRef) as ChangeDetectorRef;
  }

  public refreshUI() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  public markForCheck() {
    this.cdr.markForCheck();
  }

  public setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
    this.refreshUI();
  }
}

export abstract class ComponentHeaderComponentBase extends BaseComponentOnPush {}
